import React from 'react';

interface ConfigPanelProps {
  gridSize: number;
  maxGenerations: number;
  streamInterval: number;
  initializerType: 'Random' | 'Center' | 'Cross' | 'CenterSingle' | 'CenterCross' | 'LeftSingle' | 'LeftCross' | 'RightSingle' | 'RightCross' | 'Glider' | 'Pulsar' | 'RPentomino' | 'Beacon' | 'Toad' | 'Blinker' | 'Acorn' | 'Diehard' | 'GosperGun' | 'LWSS';
  density: number;
  seedValue: number;
  gridScale: number;
  updateConfig: (updates: any) => void;
}

const ConfigPanel: React.FC<ConfigPanelProps> = ({
  gridSize,
  maxGenerations,
  streamInterval,
  initializerType,
  density,
  seedValue,
  gridScale,
  updateConfig
}) => {
  return (
    <div className="config-panel">
      <h3>Configuration</h3>

      <div className="config-group">
        <label>
          Grid Size:
          <input
            type="number"
            value={gridSize}
            onChange={(e) => updateConfig({ gridSize: parseInt(e.target.value) })}
            min="10"
            max="100"
          />
        </label>
      </div>

      <div className="config-group">
        <label>
          Max Generations:
          <input
            type="number"
            value={maxGenerations}
            onChange={(e) => updateConfig({ maxGenerations: parseInt(e.target.value) })}
            min="10"
            max="1000"
          />
        </label>
      </div>

      <div className="config-group">
        <label>
          Stream Interval (ms):
          <input
            type="number"
            value={streamInterval}
            onChange={(e) => updateConfig({ streamInterval: parseInt(e.target.value) })}
            min="100"
            max="5000"
          />
        </label>
      </div>

      <div className="config-group">
        <label>
          Initializer Type:
          <select
            value={initializerType}
            onChange={(e) => updateConfig({ initializerType: e.target.value as any })}
          >
            <optgroup label="Basic Patterns">
              <option value="Random">Random</option>
              <option value="Center">Center (Compact Cross)</option>
              <option value="Cross">Full Cross</option>
            </optgroup>
            <optgroup label="Positioned Seeds">
              <option value="CenterSingle">Center Single</option>
              <option value="CenterCross">Center Cross</option>
              <option value="LeftSingle">Left Single</option>
              <option value="LeftCross">Left Cross</option>
              <option value="RightSingle">Right Single</option>
              <option value="RightCross">Right Cross</option>
            </optgroup>
            <optgroup label="Game of Life Patterns">
              <option value="Glider">Glider</option>
              <option value="Pulsar">Pulsar</option>
              <option value="RPentomino">R-Pentomino</option>
              <option value="Beacon">Beacon</option>
              <option value="Toad">Toad</option>
              <option value="Blinker">Blinker</option>
              <option value="Acorn">Acorn (Methuselah)</option>
              <option value="Diehard">Diehard</option>
              <option value="GosperGun">Gosper Glider Gun</option>
              <option value="LWSS">Lightweight Spaceship</option>
            </optgroup>
          </select>
        </label>
        <div className="config-hint">
          Current: <strong>{initializerType}</strong>
        </div>
      </div>

      <div className="config-group">
        <label>
          Density:
          <input
            type="number"
            value={density}
            onChange={(e) => updateConfig({ density: parseFloat(e.target.value) })}
            min="0"
            max="1"
            step="0.1"
          />
        </label>
      </div>

      <div className="config-group">
        <label>
          Seed Value:
          <input
            type="number"
            value={seedValue}
            onChange={(e) => updateConfig({ seedValue: parseInt(e.target.value) })}
            min="0"
            max="1000"
          />
        </label>
      </div>

      <div className="config-group">
        <label>
          Grid Scale:
          <input
            type="number"
            value={gridScale}
            onChange={(e) => updateConfig({ gridScale: parseFloat(e.target.value) })}
            min="0.1"
            max="3"
            step="0.1"
          />
        </label>
      </div>
    </div>
  );
};

export default ConfigPanel;
